import { deviceNeedsVerification } from "services/auth";

/**
 * Processes the user's status in snake_case format and returns a promise.
 *
 * @param {Object} userSessionPromiseResponse
 * @param {boolean} userSessionPromiseResponse.logged_in
 * @param {boolean} userSessionPromiseResponse.feature_toggles.unified_cart
 * @param {boolean} userSessionPromiseResponse.feature_toggles.affiliate_program
 * @param {boolean} userSessionPromiseResponse.feature_toggles.sardine_enabled
 * @param {boolean} userSessionPromiseResponse.feature_toggles.group_listings
 * @param {boolean} userSessionPromiseResponse.feature_toggles.decagon_enabled
 * @param {boolean} userSessionPromiseResponse.feature_toggles.zendesk_enabled
 * @param {string|null} userSessionPromiseResponse.user.guest_user_uuid
 * @param {string|null} userSessionPromiseResponse.user.user_uuid
 * @param {string|null} userSessionPromiseResponse.user.user_phone
 * @param {string|null} userSessionPromiseResponse.user.average_order_total
 * @param {Array} userSessionPromiseResponse.user.user_roles
 * @param {boolean|null} userSessionPromiseResponse.user.device_verified
 * @param {boolean|null} userSessionPromiseResponse.user.email_confirmed
 *
 * @typedef {Object} UserSessionFormatted
 * @property {boolean} isLoggedIn
 * @property {boolean} featureToggles.isUnifiedCart
 * @property {boolean} featureToggles.isAffiliateProgram
 * @property {boolean} featureToggles.isSardineEnabled
 * @property {boolean} featureToggles.isGroupListingsEnabled
 * @property {boolean} featureToggles.isDecagonEnabled
 * @property {string|null} userID
 * @property {string|null} guestUserID
 * @property {string} userPhone
 * @property {string|null} averageOrderTotal
 * @property {Array} userRoles
 * @property {boolean|null} isDeviceVerified
 * @property {boolean|null} isEmailConfirmed
 * @returns {UserSessionFormatted} A object with the processed user session info in camelCase format.
 *
 */
export const mapSessionInfoResponse = (userSessionPromiseResponse) => {
  const {
    logged_in,
    feature_toggles: {
      unified_cart,
      group_listings,
      affiliate_program,
      decagon_enabled,
      sardine_enabled,
      zendesk_enabled
    },
    user: {
      user_uuid,
      guest_user_uuid,
      average_order_total,
      device_verified,
      email_confirmed,
      user_phone,
      user_roles,
      raise_cash
    }
  } = userSessionPromiseResponse;

  return {
    isLoggedIn: logged_in,
    userID: user_uuid,
    guestUserID: guest_user_uuid,
    averageOrderTotal: average_order_total,
    isDeviceVerified:
      device_verified && !deviceNeedsVerification({ isLoggedIn: logged_in }),
    isEmailConfirmed: email_confirmed,
    userPhone: user_phone || "",
    userRoles: user_roles,
    gcxCash: raise_cash,
    featureToggles: {
      isUnifiedCart: unified_cart,
      isGroupListingsEnabled: group_listings,
      isAffiliateProgram: affiliate_program,
      isDecagonEnabled: decagon_enabled,
      isSardineEnabled: sardine_enabled,
      isZendeskEnabled: zendesk_enabled
    }
  };
};
